import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a74ed508"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "component-variable__footer__message" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "impact" }, "Impact", -1 /* HOISTED */));
const _hoisted_4 = {
    key: 0,
    class: "word"
};
const _hoisted_5 = {
    key: 1,
    class: "comma"
};
const _hoisted_6 = {
    key: 2,
    class: "word"
};
import { computed, toRef } from "vue";
import DrawerTrigger from "src/shared/v-components/ui/drawer/DrawerTrigger.vue";
import CampaignComponentVariableImpactDrawer from "src/shared/v-components/campaign-component-variable/input/inheritance/CampaignComponentVariableImpactDrawer.vue";
import { useComponentVariableImpactSummary } from "src/shared/store/component-graph-v2/composables/useComponentVariableImpactSummary";
import { useComponentVariableChildComponentIds } from "src/shared/store/component-graph-v2/composables/useComponentVariableChildComponentIds";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ComponentVariableImpactMessage',
    props: {
        componentId: {},
        variableName: {}
    },
    setup(__props) {
        const props = __props;
        const { componentVariableChildComponentIds } = useComponentVariableChildComponentIds(toRef(props, "componentId"), toRef(props, "variableName"));
        const { componentVariableImpactSummary } = useComponentVariableImpactSummary(componentVariableChildComponentIds);
        const impactedCampaignsDescription = computed(() => {
            const { campaignIds } = componentVariableImpactSummary.value;
            if (campaignIds.size === 0) {
                return "";
            }
            if (campaignIds.size === 1) {
                return "1 Campaign";
            }
            return `${campaignIds.size} Campaigns`;
        });
        const impactedCreativesDescription = computed(() => {
            const { nonRootComponentIds } = componentVariableImpactSummary.value;
            if (nonRootComponentIds.size === 0) {
                return "";
            }
            if (nonRootComponentIds.size === 1) {
                return "1 Creative";
            }
            return `${nonRootComponentIds.size} Creatives`;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", _hoisted_1, [
                _createVNode(DrawerTrigger, null, {
                    trigger: _withCtx(({ openDrawer }) => [
                        _createElementVNode("div", {
                            class: "impact-container",
                            onClick: openDrawer
                        }, [
                            _hoisted_3,
                            (_unref(componentVariableImpactSummary).campaignIds.size)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(impactedCampaignsDescription.value), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                            (_unref(componentVariableImpactSummary).campaignIds.size &&
                                _unref(componentVariableImpactSummary).nonRootComponentIds.size)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_5, ","))
                                : _createCommentVNode("v-if", true),
                            (_unref(componentVariableImpactSummary).nonRootComponentIds.size)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(impactedCreativesDescription.value), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                        ], 8 /* PROPS */, _hoisted_2)
                    ]),
                    drawer: _withCtx(({ drawerClosed }) => [
                        _createVNode(CampaignComponentVariableImpactDrawer, {
                            "component-id": _ctx.componentId,
                            "variable-name": _ctx.variableName,
                            onClosed: drawerClosed
                        }, null, 8 /* PROPS */, ["component-id", "variable-name", "onClosed"])
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
